import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import moment from "moment-timezone";
import { connect, useDispatch } from "react-redux";
import {
    Card,
    CardBody,
    CardTitle,
    CardHeader,
    Container,
    Button,
    Row,
    Col,
    CardImg,
    Media,
    FormGroup,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    Badge
} from "reactstrap";
import { studentsLifetimePlan as studentsLifetimePlans } from "util/DataList";
import { useHistory } from 'react-router-dom';
import { fetchLtpItem } from "redux/ManageLifeTimePlan/ManageLifeTimePlanActions";
import { hasActiveAccess, getSpecialtyFields } from 'config/subscriptionPlans';
import { getStorageUrl } from 'util/specialtyCollections';
const CourseItemList = (props) => {

    const dispatch = useDispatch();

	let studentsLifetimePlan = studentsLifetimePlans

	useEffect(() => {
		dispatch(fetchLtpItem())
	}, [])

	useEffect(() => {

		if (props.fetchLtpItem.ltpitems.length) {
			const matchedItem = props.fetchLtpItem.ltpitems.find(
			  (item) => props.userDetails.email === item.email
			);
			if (matchedItem) {
				studentsLifetimePlan.push(props.userDetails.email)
				setSubscribe("unlock")
			}
		 }

	}, [props.fetchLtpItem]);

    const history = useHistory();

    let lessonNumber = 0;
    
    const [item,setItem ] = useState(props.item)
    
    if(item.category){
        item.category.forEach(element => {
            lessonNumber = lessonNumber +  element.lessons.length
        });
    }
    
    const [lessonLength, setLessonNumber] = useState(lessonNumber)

    const handleStartCourse = (e, item) => {
        props.courseCallback(item)
    }

    const [subscribe, setSubscribe] = useState('lock');
    const [ultimateSubscribe, setUltimateSubscribe] = useState('lock');


    const fetchSubscriptionDetails = () => {
        // Modern access check — same as rest of the app (covers lifetime, UAS, trial, subscription)
        if (hasActiveAccess(props.userDetails, props.activeSpecialty)) {
            setSubscribe('unlock')
            const uasField = getSpecialtyFields(props.activeSpecialty).ultimateAdvisingStudent;
            if (props.userDetails[uasField] == true || props.userDetails[uasField] == "true") {
                setUltimateSubscribe('unlock')
            }
            return;
        }

        // Legacy: check email-based lifetime plan list
        if (studentsLifetimePlan.includes(props.userDetails.email)) {
            setSubscribe('unlock')
            return;
        }

        // Legacy: check old Stripe subscription
        if (props.fetchDetailsSubscription.fetchdetailssubscription.length) {
            const subsDetails = props.fetchDetailsSubscription.fetchdetailssubscription[0]
            if (subsDetails.status == "active" || subsDetails.status == "trialing") {
                setSubscribe('unlock')
            } else if (subsDetails.cancel_at_period_end) {
                const date = new Date();
                const secondsSinceEpoch = Math.floor(date.getTime() / 1000);
                if (secondsSinceEpoch > subsDetails.canceled_at) {
                    setSubscribe('lock')
                } else {
                    setSubscribe('unlock')
                }
            } else {
                setSubscribe('lock')
            }
        } else {
            setSubscribe('lock')
        }
    }
    useEffect(() => {

        fetchSubscriptionDetails()
    
    }, [props.fetchDetailsSubscription])

    useEffect(() => {
        fetchSubscriptionDetails()

    },[])


    const members = JSON.parse(item.members);
    const hasFree = members.some(m => m.value === "free");
    const hasPro = members.some(m => m.value === "pro");
    const hasUltimate = members.some(m => m.value === "ultimate");

    const canAccessFree = hasFree;
    const canAccessPro = hasPro && (subscribe === "unlock" );
    const canAccessUltimate = hasUltimate && (ultimateSubscribe === "unlock" );

return (
    <Col xl="4" lg="6" md="12" sm="12" className="d-flex flex-column flex-wrap">
   
    <Card className="shadow rounded mb-5 h-100" outline>
        <CardBody className="">
            <Row className="h-100 d-flex flex-row flex-wrap">
                <Col lg="12" md="12" sm="12" className=" d-flex flex-column flex-nowrap">
                    {item.courseThumbnail != "" ? 
                    
                        <CardImg
                            alt="..."
                            src={getStorageUrl('img-tpc-courses', item.courseThumbnail, props.activeSpecialty)}
                            
                            top
                            // style={{height : "100%", objectFit: "fill", width:"100%"}}
                            // className="d-flex flex-column flex-wrap"
                        />
                        
                        :

                        <CardImg
                            alt="..."
                        
                            src={require("assets/img/brand/no-image.jpg")}
                            top
                            // style={{height : "100%", objectFit: "fill", width:"100%"}}
                            // className="d-flex flex-column flex-wrap"
                        />
                    }
                </Col>
                <Col lg="12" md="12" sm="12" className="d-flex flex-column flex-wrap">
                    <div className="mb-auto py-3 px-2">
                        <h3 >{item.courseTitle}</h3>
                        <small>
                            { 
                                item.courseDescription.length > 99 ?
                                // <>
                                //     {/* {item.courseDescription.slice(0, 85) } <span className="text-primary " role="button" onClick={e => handleStartCourse(e, item)}> ...read more </span> */}
                                // </>
                                <>{item.courseDescription.slice(0, 85)}...</>
                                : item.courseDescription
                            }
                            
                            
                        </small>
                    </div>
                    <div className="mb-1  px-2">
                        {/* <Button
                            color="default"
                            className="rounded-pill"
                            onClick={e => handleStartCourse(e, item)}
                            >
                            <i className="fas fa-play"></i>&nbsp;&nbsp;Start Lesson
                        </Button> */}

                        

                        
                        {canAccessFree ? (
                            // FREE ACCESS
                            <Button
                                color="default"
                                className='w-100 font-weight-bolder'
                                onClick={e => handleStartCourse(e, item)}
                            >
                                <i className="fas fa-play-circle"></i> &nbsp;Start Course
                            </Button>
                        ) : canAccessPro ? (
                            // PRO ACCESS
                            <Button
                                color="default"
                                className='w-100 font-weight-bolder'
                                onClick={e => handleStartCourse(e, item)}
                            >
                                <i className="fas fa-play-circle"></i> &nbsp;Start Course
                            </Button>
                        ) : canAccessUltimate ? (
                            // ULTIMATE ACCESS (course requires ultimate but user has ultimate)
                            <Button
                                color="default"
                                className='w-100 font-weight-bolder'
                                onClick={e => handleStartCourse(e, item)}
                            >
                                <i className="fas fa-play-circle"></i> &nbsp;Start Course
                            </Button>
                        ) : (
                            // Course requires subscription but user does NOT have access
                            <Button
                                color="success"
                                className="w-100 font-weight-bolder"
                                onClick={(e) => {
                                    e.preventDefault();
                                    history.push('/client/plans');
                                }}
                            >
                                <i className="fas fa-crown mr-1"></i> View Plans
                            </Button>
                        )}

                        
                        
                        <div className="mt-2 mb-1 px-1">
                            <div className="mb-1">
                                {
                                    JSON.parse(item.members).map((member) => {
                                        return <Badge className="mr-1" color={member.value == "ultimate" ? "danger" : member.value == "pro" ? "warning" : "info"}>{member.label}</Badge>
                                    })
                                  
                                }
                            </div>
                            <small className="mr-3">{item.category !== undefined ? lessonLength : 0} Lessons</small>
                            <small className="mr-3">By: {item.instructorName} </small>
                        </div>
                        
                    </div>
                    
                </Col>
            </Row>
        </CardBody>
    </Card>
   

    </Col>
)


}

const mapStateToProps = (state) => {
  return {
    userDetails: state.loginAuth.userDetails,
    fetchDetailsSubscription : state.fetchDetailsSubscription,
    adminUser : state.adminUser,
    fetchLtpItem : state.fetchLtpItem,
    activeSpecialty: state.specialty.activeSpecialty,
  };
};

export default connect(mapStateToProps)(CourseItemList);